import { render } from "./cpt-icon-quota.vue?vue&type=template&id=237bc9cc&scoped=true"
import script from "./cpt-icon-quota.vue?vue&type=script&lang=js"
export * from "./cpt-icon-quota.vue?vue&type=script&lang=js"

import "./cpt-icon-quota.vue?vue&type=style&index=0&id=237bc9cc&scoped=true&lang=css"

import exportComponent from "../../../../../.tjp/v1/FEharBh6/xdkj/daping/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.20_vue@3.4.20_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237bc9cc"]])

export default __exports__